import { SearchHelper } from './search.helper';
import * as _ from 'lodash';

const countryList = require('../../../data/countries.json');

export const OptionPhones = countryList.map((country: any) => ({
  value: _.get(country, 'cca2'),
  label: _.get(country, 'name.common') + ` (+${_.get(country, 'callingCode')})`,
  // replace space with * United stated -> *united*stated*
  extra: SearchHelper.getSearchText((country?.name?.common || '') + ' ' + country.callingCode),
  code: `(+${_.get(country, 'callingCode')})`,
}));

export const OptionCountries = countryList.map((country: any) => ({
  value: _.get(country, 'cca2'),
  label: _.get(country, 'name.common'),
  extra: SearchHelper.getSearchText(country?.name?.common || ''),
  code: `(+${_.get(country, 'callingCode')})`,
}));
